module.exports = __webpack_public_path__ + "img/afk-arena.7abaa579.png";